 kombi.handleReservationSelection = function() {
    document.querySelectorAll('.select-reservation').forEach(function(button) {
        button.addEventListener('click', function(event) {
            let nextUrl = button.getAttribute('href');
            localStorage.setItem('nextUrl', nextUrl);
        });
    });
}